import axios from 'axios';
import { API_BASE_URL, API_TIMEOUT } from '../configs/configs.js';
import {
  clearSession,
  getSessionToken,
  isProtectedPath,
  loginPath,
} from '../utils/session';
import { getErrorMessage } from '../utils/apiError';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest', // CSRF protection
  },
  withCredentials: false,
});

// Attach the token only while it's valid; an expired one is cleared instead of sent.
apiClient.interceptors.request.use(config => {
  const token = getSessionToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  response => response,
  error => {
    const status = error?.response?.status;

    if (status === 401) {
      // Ending the session updates the navbar everywhere; only protected pages
      // need to bounce to sign-in, and they come back here afterwards.
      clearSession();
      const { pathname, search } = window.location;
      if (isProtectedPath(pathname)) {
        window.location.assign(loginPath(`${pathname}${search}`));
      }
    }

    error.userMessage = getErrorMessage(error);
    return Promise.reject(error);
  }
);

// Kept for older callers; prefer clearSession from utils/session.
const clearAuthData = clearSession;

const getUserFriendlyErrorMessage = (status, data) =>
  getErrorMessage({ response: { status, data } });

export { clearAuthData, getUserFriendlyErrorMessage };
export default apiClient;
